import React, { useEffect, useState } from 'react';
import { Stack, TextField } from '@mui/material';
import { useSearchParams } from 'react-router-dom';
import { useAppDispatch } from '../../../../../app/hooks';
import { useUpsertRuleMutation, useDeleteRuleMutation, contractApi } from '../../../../../services/ContractService';
import { RuleCommands } from './RuleCommands';

interface StatusBasedCaseRateProps {
  ruleId: string;
  ruleString?: string;
  ruleDescription?: string;
}

const StatusBasedCaseRate: React.FC<StatusBasedCaseRateProps> = ({ ruleId, ruleString = '', ruleDescription = '' }) => {
  const [searchParams] = useSearchParams();
  const contractId = searchParams.get('id');
  const dispatch = useAppDispatch();
  const [rule, setRule] = useState({ code: '', rate: 0 });
  const [upsertRule] = useUpsertRuleMutation();
  const [deleteRule] = useDeleteRuleMutation();

  const save = async () => {
    if (!contractId) return;
    
    try {
      await upsertRule({
        contractId: contractId,
        ruleId,
        ruleType: 'StatusBasedCaseRate',
        priority: 0,
        ruleString: JSON.stringify(rule),
        description: ruleDescription ?? ''
      }).unwrap();
      dispatch(contractApi.util.invalidateTags(['RuleList']));
    } catch (error) {
      console.error('Failed to save rule:', error);
    }
  };

  const ruleDelete = async () => {
    try {
      await deleteRule({ ruleId }).unwrap();
      dispatch(contractApi.util.invalidateTags(['RuleList']));
    } catch (error) {
      console.error('Failed to delete rule:', error);
    }
  };

  useEffect(() => {
    if (ruleString !== '') {
      try {
        const r: { code: string, rate: number } = JSON.parse(ruleString);
        setRule(r);
      } catch (error) {
        console.error('Failed to parse rule string:', error);
        setRule({ code: '', rate: 0 });
      }
    }
  }, [ruleString, ruleId]);

  return (
    <React.Fragment>
      <Stack direction='row' gap={1}>
        <TextField 
          label='Code' 
          value={rule.code} 
          sx={{ width: '150px' }}
          onChange={(e) => setRule({ ...rule, code: e.target.value })}
        />
        <TextField 
          type='number' 
          label='Rate' 
          value={rule.rate} 
          sx={{ width: '150px' }}
          onChange={(e) => setRule({ ...rule, rate: Number(e.target.value) })}
        />
      </Stack>
      <RuleCommands 
        saveCommand={save} 
        deleteCommand={ruleDelete} 
        isNewRule={ruleId === '0'}
      />
    </React.Fragment>
  );
};

export { StatusBasedCaseRate };